<template><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="M-4.74788e-05 5.0001C-5.39445e-05 2.23867 2.23852 8.77294e-05 4.99995 8.52943e-05L12.9999 7.82396e-05L-2.87476e-05 13L-4.74788e-05 5.0001Z"
              fill="currentColor"/>
        <path d="M20 14.9999C20 17.7613 17.7614 19.9999 15 19.9999L7.00002 19.9999L20 7L20 14.9999Z" fill="currentColor"/>
    </g>
</svg>
</template>